var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_1500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.85058 10.753H12.416V16.6886M9.87569 16.6886H14.9813M12.4408 6.37682V6.93016M3.62522 19.4448C7.47293 23.9631 16.5277 23.9631 20.3755 19.4448C23.9194 15.283 23.6504 7.1371 19.3849 3.5741C15.5641 0.38269 8.4365 0.38269 4.61577 3.5741C0.350202 7.1371 0.0812228 15.283 3.62522 19.4448Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_1500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};

export { SvgInfo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNjNfMTUwMCkiPgogICAgICAgIDxwYXRoIGQ9Ik05Ljg1MDU4IDEwLjc1M0gxMi40MTZWMTYuNjg4Nk05Ljg3NTY5IDE2LjY4ODZIMTQuOTgxM00xMi40NDA4IDYuMzc2ODJWNi45MzAxNk0zLjYyNTIyIDE5LjQ0NDhDNy40NzI5MyAyMy45NjMxIDE2LjUyNzcgMjMuOTYzMSAyMC4zNzU1IDE5LjQ0NDhDMjMuOTE5NCAxNS4yODMgMjMuNjUwNCA3LjEzNzEgMTkuMzg0OSAzLjU3NDFDMTUuNTY0MSAwLjM4MjY5IDguNDM2NSAwLjM4MjY5IDQuNjE1NzcgMy41NzQxQzAuMzUwMjAyIDcuMTM3MSAwLjA4MTIyMjggMTUuMjgzIDMuNjI1MjIgMTkuNDQ0OFoiCiAgICAgICAgICAgICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS43MTQyOSIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgICAgICAgICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8yNjNfMTUwMCI+CiAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICAgICAgPC9jbGlwUGF0aD4KICAgIDwvZGVmcz4KPC9zdmc+Cg==";